import React from "react";
import Translate from "react-translate-component";
import FormattedAsset from "../../Utility/FormattedAsset";
export const TransferFromBlind = ({
  op,
  linkToAccount,
  fromComponent
}) => {
  return /*#__PURE__*/React.createElement("span", null, linkToAccount(op[1].to), "\xA0", /*#__PURE__*/React.createElement(Translate, {
    component: "span",
    content: fromComponent === "proposed_operation" ? "proposal.received" : "transaction.received"
  }), "\xA0", /*#__PURE__*/React.createElement(FormattedAsset, {
    style: {
      fontWeight: "bold"
    },
    amount: op[1].amount.amount,
    asset: op[1].amount.asset_id
  }));
};